import FileUploader from "../utils/FIleUploader";
import "./PendingInvoice.css";
import { useState } from "react";

function PendingInvoice(props) {
  const data = props.data;

  return (
    <div className="pending-invoice">
      <h3>Factura #{data.invoice_number}</h3>
      <p>Periodo {data.period}</p>
      <p>Valor ${data.value}</p>

      <button className="btn btn-primary btn-pse">Pagar PSE</button>
      <FileUploader invoice_number={data.invoice_number}></FileUploader>
    </div>
  );
}

export default PendingInvoice;
